import { GetAssessmentResult } from "tech-health-assessment-sdk/dist";
import { api } from "../../../../../services/core-api-service";

class AdminAssessmentService {
    public async getAssessment(assessmentId: string): Promise<GetAssessmentResult> {
        return api.admin.getAssessment(assessmentId)
    }
}

export const service = new AdminAssessmentService()